<div class="filling-method">
    <mat-expansion-panel [expanded]="true" [style]="{'background-color': '#F3F4F6' }">
        <mat-expansion-panel-header>
            <mat-panel-title>
                Способ заполнения
            </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
            <div class="controls">
                <button
                    class="control"
                    [class.active]="currentButton==='Number_Enter'"
                    mat-button
                    (click)="switchContent(numberEnter, 'Number_Enter')"
                >Ввод числа
                </button>
                <button
                    class="control"
                    [class.active]="currentButton==='List_Select'"
                    mat-button
                    (click)="switchContent(list, 'List_Select')"
                >Выбор из списка
                </button>
                <button
                    class="control"
                    [class.active]="currentButton==='Ias_Sport'"
                    mat-button
                    (click)="switchContent(iasSport, 'Ias_Sport')"
                >ИАС Спорт
                </button>
            </div>
            <div class="content">
                <ng-container *ngTemplateOutlet="content || numberEnter"></ng-container>
                <ng-template #iasSport>
                    @if (value) {
                        <pas-unit-selector
                            [units]="units"
                            [unit]="value.fillType==='Ias_Sport' ? value.unit: emptyUnit"
                            (unitChange)="onUnitChange($event)"
                        />
                    }
                </ng-template>
                <ng-template #numberEnter>
                    @if (value) {
                        <pas-unit-selector
                            [units]="units"
                            [unit]="value.fillType==='Number_Enter' ? value.unit: emptyUnit"
                            (unitChange)="onUnitChange($event)"
                        />
                    }
                </ng-template>
                <ng-template #list>
                    @if (value) {
                        <pas-index-items-list [items]="value.indexItems" (itemsChange)="onItemsChange($event)" />
                    }
                </ng-template>
            </div>
        </div>
    </mat-expansion-panel>
    @if(currentButton==='List_Select'){
        <form
            class="filling-without_remarks"
            (change)="onFillingWithoutRemarksChange($event)"
        >
            <h5>Без нарушений</h5>
            <input class="remarktype-textarea filling-without_remarks__search" matInput [formControl]="searchIndexInWithoutRemarks" placeholder="Поиск индекс"/>
            @for (item of (filteredSearchIndexInWithoutRemarks$ | async); track item; let i = $index) {
                <label class="radio">
                    <input
                        type="radio"
                        name="filling-without_remarks"
                        [value]="JSON.stringify(item)"
                        [checked]="item.noViolations"
                    />
                    {{ item.name }} ({{ item.shortName }})
                </label>
            }
        </form>
    }
</div>
